<template>
  <div
    v-if="alert"
    class="low-balance__card"
    :data-qa="`low-balance-alert${alert ? '-show' : ''}`">
    <div class="low-balance__card-content">
      <div
        class="low-balance__card-col-1"
        data-qa="low-balance-alert-date">
        <div>{{ $t('User.WorkOnSiteWillBeImpossible.0') }}</div>
        <div>{{ $t('Common.DateFrom') }} <span class="bold">{{ date }}</span> {{ $t('User.WorkOnSiteWillBeImpossible.1') }}</div>
      </div>
      <div class="low-balance__card-col-2">
        <div class="h9-label px-0 pb-1">
          {{ $t('User.CurrentBalance') }}
        </div>
        <div
          class="text-left h7-text black--text"
          data-qa="low-balance-alert-summ">
          {{ settings.balance }} {{ settings && settings.currency ? settings.currency.shortTitle : $t('Tenders.hrn') }}
        </div>
      </div>
      <div class="low-balance__card-col-3">
        <CreateInvoiceDialog
          data-qa="low-balance-alert-create-invoice"/>
        <sButton
          class="my-auto"
          data-qa="btn-low-balance-alert-close"
          icon="cancel"
          small
          type="text"
          @click="close"/>
      </div>
    </div>
  </div>
</template>
<script>
import CreateInvoiceDialog from 'components/billing/CreateInvoiceDialog.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'lowBalanceAlert',
  data() {
    return {
      alert: false,
      loading: false,
      date: moment().format('DD.MM.YYYY')
    }
  },
  mounted() {
    this.$root.$on('showLowBilingAlert', this.open)
    this.$root.$on('closeLowBilingAlert', this.close)
  },
  beforeDestroy() {
    this.$root.$off('showLowBilingAlert', this.open)
    this.$root.$off('closeLowBilingAlert', this.close)
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
  },
  methods: {
    open() {
      this.date = moment(moment().format('M'), 'M')
        .add( this.settings.userAccess?.checkBillingResult?.delayDays, 'days').format('DD.MM.YYYY')
      this.alert = true
    },
    close() {
      this.alert = false
    },
  },
  components: {
    CreateInvoiceDialog
  }
}
</script>
<style lang="scss">
.low-balance {
  &__card {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    color: rgba(var(--black-color-rgba), 0.87);
    padding: 16px 16px 16px 36px;
    border-radius: 4px;
    background-color: var(--v-main__light_green-base);
    border-color: var(--v-main__light_green-base);
    text-align: left;
    margin-bottom: 14px;
    &-content {
      display: flex;
      justify-content: space-between;
    }
    &-col-1 {
      font-size: 14px;
      line-height: 18px;
    }
    &-col-2 {
      width: 17%;
    }
    &-col-3 {
      display: flex;
    }
  }
}
</style>
